import React from 'react';
import Block from './Block';

const Submenu = ({children = null}) => (
		<Block
			modifiers={{
				submenu: true,
				colorSchemeDefault: true,
				borderTop: true,
				borderTopMulti: true,
				borderBottom: true,
				borderBottomMulti: true
			}}
		>
			{children}
		</Block>
	)
;

export default Submenu;
